<template>
  <div class='rights'>
    <div class='title'>
      <div>{{$vi18n('$i18n# 账号权益 #i18n$')}}</div>
      <div class='level-desc'>
        <span @click.self='levelDescVisible = true'>{{$vi18n('$i18n# 等级权益 #i18n$')}}</span>
      </div>
    </div>
    <div class='main'>
      <div class='level-carousel'>
        <div class='level-info'>
          <span class='level-title'>
						{{ levelList[this.level - 1 > 0 ? this.level - 1 : 0].name }}&nbsp;
					</span>
          <div class='level-subtitle'>MINI DEVELOPER</div>
        </div>

        <!-- $vi18n('$i18n# 等级信息 #i18n$') -->
        <div class='level-icon'>
          <level-card
            v-for='(item, index) in levelData'
            :key='index'
            :score='item.s'
            :level='item.l'
            :name='levelList[item.l - 1 > 0 ? item.l - 1 : 0].name'
            :currentLevel='level'
            @selectLevel='($event) => clickChange($event - 1)'
          ></level-card>
        </div>
        <div class='level-info-progress'>
          <span class='level-info-progress-text'>{{$vi18n('$i18n# 信用分 #i18n$')}}</span>
          <div class='progress'>
            <div class='line' :style="{ width: progress + '%' }">
              <div class='score'>{{ score }}</div>
            </div>
          </div>
        </div>
      </div>
      <section class='level-info'>
        <h3>
          <span>
            {{ levelList[current].name }} - {{$vi18n('$i18n# 等级权益 #i18n$')}}
          </span>
        </h3>
        <article class='info-list'>
          <div class='item'>
            <div class='icon icon-ewcdsl'></div>
            <div class='tit'>{{$vi18n('$i18n# 额外存档数量 #i18n$')}}</div>
            <div class='info'>
              {{$vi18n('$i18n# 增加{ewcdsl}个#i18n$', {ewcdsl: levelList[current].ewcdsl})}}
            </div>
          </div>
          <div class='item'>
            <div class='icon icon-ffdsgn'></div>
            <div class='tit'>{{$vi18n('$i18n# 付费打赏功能 #i18n$')}}</div>
            <div class='info'>{{ levelList[current].ffdsgn }}</div>
          </div>
          <div class='item'>
            <div class='icon icon-xbsr'></div>
            <div class='tit'>{{$vi18n('$i18n# 贡献点收入 #i18n$')}}</div>
            <div class='info'>{{ levelList[current].xbsr }}</div>
          </div>
          <div class='item'>
            <div class='icon icon-mndsr'></div>
            <div class='tit'>{{$vi18n('$i18n# 迷你豆收入 #i18n$')}}</div>
            <div class='info'>{{ levelList[current].mndsr }}</div>
          </div>
          <div class='item'>
            <div class='icon icon-sjfxptqx'></div>
            <div class='tit'>{{$vi18n('$i18n# 数据分析平台权限 #i18n$')}}</div>
            <div class='info'>{{ levelList[current].sjfxptqx }}</div>
          </div>
          <div class='item'>
            <div class='icon icon-ngsdsyqx'></div>
            <div class='tit'>{{$vi18n('$i18n# 内购商店使用权限 #i18n$')}}</div>
            <div class='info'>
              <p>
                {{$vi18n('$i18n# 可售卖物品数量 #i18n$')}}：{{
                  levelList[current].ngsdsyqx[0]
                }}
              </p>
              <p>
                {{$vi18n('$i18n# 迷你币价格范围 #i18n$')}}：0~{{
                  levelList[current].ngsdsyqx[1]
                }}
              </p>
              <p>
                {{$vi18n('$i18n# 迷你豆价格范围 #i18n$')}}：0~{{
                  levelList[current].ngsdsyqx[2]
                }}
              </p>
            </div>
          </div>
        </article>
      </section>
      <NoviciateMask v-if="isNoviciateDeveloper"></NoviciateMask>
    </div>
    <!-- <div class='loading' v-loading='loading' v-if='loading'></div> -->
    <el-dialog
      :title="$vi18n('$i18n# 开发者等级说明 #i18n$')"
      :visible.sync='levelDescVisible'
      width='900px'
      class='level-desc-dialog'
      append-to-body
    >
      <div class='q-group'>
        <p class='q'>Q：{{$vi18n('$i18n# 什么是开发者等级 #i18n$')}}?</p>
        <p class='a'>A：{{$vi18n('$i18n# 开发者等级是根据开发者的信用值来评定的，开发者可以通过达成一系列的加分任务（里程碑），晋升到更高级别的开发者 ，获取更高的收益分成 ，更多存档位置 ，更强的付费编辑功能。#i18n$')}}</p>
      </div>
      <div class='q-group'>
        <p class='q'>Q：{{$vi18n('$i18n# 怎样获得信用值 #i18n$')}}?</p>
        <p class='a'>A：{{$vi18n('$i18n# 地图被下载、评论、进入（联机)；每张地图根据标准制定了多档里程碑，达成后即可获得开发者信用值，每个地图的相同里程碑不能重复获得（地图下架)，数据被清空并不会减少信用值 #i18n$')}}</p>
      </div>
      <div class='q-group'>
        <p class='q'>Q：{{$vi18n('$i18n# 哪些情况会让信用值减少 #i18n$')}}?</p>
        <p class='a'>A：{{$vi18n('$i18n# 作品内容里含有禁止内容，会扣分且下架作品，严重的直接封号、禁止账号资金并永远列入黑名单；当出现违规行为时会出现扣分，包括但不限于内容低俗恶俗、黑科技、盗图、内购道具与实际效果不符、欺诈消费者等 #i18n$')}}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import LevelCard from './level-card.vue';
import NoviciateMask from '@/components/NoviciateMask'
import { getLevel } from '@/api/account.js';
export default {
	name: 'right',
	components: {
    LevelCard,
    NoviciateMask
  },
	data() {
		return {
			levelDescVisible: false,
			xbsr: '',
			mndsr: '',
			levelList: [],
			level: 0,
			score: 0,
			laoding: false,
			levelData: [
				{ l: 1, need: 0, s: 0 },
				{ l: 2, need: 0, s: 0 },
				{ l: 3, need: 0, s: 0 },
				{ l: 4, need: 0, s: 0 },
				{ l: 5, need: 0, s: 0 },
				{ l: 6, need: 0, s: 0 },
				{ l: 7, need: 0, s: 0 },
			],
			current: 0,
			progress: 0,
			noLevel: ''
		};
	},
  computed: {
    ...mapState(['developerInfo']),
    isNoviciateDeveloper() {
      return this.developerInfo.dev_state === 2
    },
  },
	created() {
		this.initData();
		this.getLevelHandler();
	},
	methods: {
		clickChange(current) {
			this.current = current;
		},
		format(percentage) {
			return percentage * 100;
		},
		initData() {
			const xbsr = this.$vi18n('$i18n# 内购收入利润的70% #i18n$');
			const mndsr = this.$vi18n('$i18n# 内购收入利润的70% #i18n$');
			this.noLevel = '',
			this.levelList = [
				{
					id: 'stardust',
					name: this.$vi18n('$i18n# 星尘 #i18n$'),
					ewcdsl: 10,
					ffdsgn: this.$vi18n('$i18n# 开启 #i18n$'),
					xbsr,
					mndsr,
					sjfxptqx: this.$vi18n('$i18n# 开启 #i18n$'),
					ngsdsyqx: [10, 99, 199],
				},
				{
					id: 'nebula',
					name: this.$vi18n('$i18n# 星云 #i18n$'),
					ewcdsl: 15,
					ffdsgn: this.$vi18n('$i18n# 开启 #i18n$'),
					xbsr,
					mndsr,
					sjfxptqx: this.$vi18n('$i18n# 开启 #i18n$'),
					ngsdsyqx: [20, 99, 299],
				},
				{
					id: 'star',
					name: this.$vi18n('$i18n# 恒星 #i18n$'),
					ewcdsl: 25,
					ffdsgn: this.$vi18n('$i18n# 开启 #i18n$'),
					xbsr,
					mndsr,
					sjfxptqx: this.$vi18n('$i18n# 开启 #i18n$'),
					ngsdsyqx: [30, 199, 499],
				},
				{
					id: 'giant',
					name: this.$vi18n('$i18n# 红巨星 #i18n$'),
					ewcdsl: 45,
					ffdsgn: this.$vi18n('$i18n# 开启 #i18n$'),
					xbsr,
					mndsr,
					sjfxptqx: this.$vi18n('$i18n# 开启 #i18n$'),
					ngsdsyqx: [50, 299, 999],
				},
				{
					id: 'superstar',
					name: this.$vi18n('$i18n# 超巨星 #i18n$'),
					ewcdsl: 55,
					ffdsgn: this.$vi18n('$i18n# 开启 #i18n$'),
					xbsr,
					mndsr,
					sjfxptqx: this.$vi18n('$i18n# 开启 #i18n$'),
					ngsdsyqx: [80, 399, 2999],
				},
				{
					id: 'supernova',
					name: this.$vi18n('$i18n# 超新星 #i18n$'),
					ewcdsl: 65,
					ffdsgn: this.$vi18n('$i18n# 开启 #i18n$'),
					xbsr,
					mndsr,
					sjfxptqx: this.$vi18n('$i18n# 开启 #i18n$'),
					ngsdsyqx: [100, 499, 5999],
				},
				{
					id: 'blackhole',
					name: this.$vi18n('$i18n# 黑洞 #i18n$'),
					ewcdsl: 90,
					ffdsgn: this.$vi18n('$i18n# 开启 #i18n$'),
					xbsr,
					mndsr,
					sjfxptqx: this.$vi18n('$i18n# 开启 #i18n$'),
					ngsdsyqx: [150, 599, 9999],
				},
				// {
				// 	id: 'blackhole',
				// 	name: '$vi18n('$i18n# 黑洞 #i18n$')',
				// 	ewcdsl: 90,
				// 	ffdsgn: '$vi18n('$i18n# 开启 #i18n$')',
				// 	xbsr,
				// 	mndsr,
				// 	sjfxptqx: '$vi18n('$i18n# 开启 #i18n$')',
				// 	ngsdsyqx: [150, 599, 9999],
				// },
			];
			console.log(this.levelList);
		},
		async getLevelHandler() {
			this.loading = true;
			try {
				const res = await getLevel({
					uin: sessionStorage.getItem('uin'),
				});
        const data = res.data || {};
				this.loading = false; // data.score
				this.score = data.score;

				const arr = [];
        
				for (const obj of data.config) {
					arr.push({
						l: obj.l,
						s: obj.s,
						need: obj.s - this.score,
					});
					if (obj.s <= this.score) {
						this.level = obj.l;
					}
				}
        console.log(arr);
				this.levelData = arr;
				this.getScrossProgress();
			} catch (error) {
				this.loading = false;
				console.log(error);
			}
		},
		getScrossProgress() {
			const each = 100 / (this.levelData.length - 1);
			let pre = 0;
			this.levelData.map((item) => {
				if (item.need <= 0) {
					this.progress += each;
					pre = item.s;
				} else if (pre < this.score < item.s && item.need > 0) {
					if (this.score - pre < 0) {
						return;
					}
					this.progress =
						this.progress + ((this.score - pre) / (item.s - pre)) * each;
					pre = item.s;
				}
			});
			this.progress = this.progress - each;
		}
	},
};
</script>

<style lang='scss'>
.el-progress-bar__inner {
  background: linear-gradient(0deg, #0f5dd9, #2349c0, #0f5dd9, #58c2f5, #8eedfc, #00bff9);
}
.el-progress-bar > .el-progress-bar__outer {
  background-color: #443e77;
  opacity: 0.9;
}
.no-level {
  background-image: url('../../../assets/images/icon_Notunlocked.png');
  background-repeat: no-repeat;
  text-align: center;
  text-align: center;
  height: 96px;
  line-height: 138px;
  background-position: 50% 50%;
}
.level-btn {
  background-image: url('../../../assets/images/btn_stardust.png');
  width: 76px;
  height: 38px;
  text-align: center;
  line-height: 37px;
  position: relative;
  left: -27px;
  cursor: pointer;
  z-index: 100;
}
.level-btn1 {
  left: -10px;
}
.level-btn2 {
  left: -21px;
}
.level-btn3 {
  left: -6px;
}
.circle1 {
  margin-left: -47px;
}
.circle2 {
  margin-left: -47px;
}
.icon-circle {
  background-image: url('../../../assets/images/icon_point1.png');
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  position: absolute;
  margin-top: -23px;
  z-index: 99;
}
.circles {
  margin-left: -36px;
}
.circle7 {
  margin-left: 8px;
}
.circle4 {
  margin-left: -22px;
}

.circle5 {
  margin-left: -11px;
}
.circle6 {
  margin-left: 0px;
}
.level-carousel {
  margin: 0 auto;
  width: 959px;
  height: 407px;
  background-size: 100% 100%;
  background-image: url('../../../assets/images/bg_mainpicture.png');

  .level-info {
    padding: 32px 0px 0px 36px;

    .level-subtitle {
      width: 226px;
      height: 20px;
      font-size: 27px;

      font-family: 'FZCuYuan-M03S';
      font-weight: 400;
      color: #ffffff;
      line-height: 4px;
    }
    .level-title {
      width: 86px;
      height: 41px;
      font-size: 43px;
      font-family: 'FZCuYuan-M03S';
      font-weight: 400;
      color: #ffffff;
      line-height: 90px;
    }
  }
  .level-icon {
    margin: 40px 51px 0 72px;
    display: flex;
    justify-content: space-between;
    position: relative;
    z-index: 1;
  }
  .level-info-progress {
    position: relative;
    display: flex;
    align-items: center;
    .level-info-progress-text {
      width: 100px;
      // position: absolute;
      font-size: 18px;
      color: #ffffff;
      transform: translateY(-12px);
      text-align: center;
    }
    .progress {
      background-image: url('../../../assets/images/icon_progressbarbehind.png');
      background-size: 100% 100%;
      width: 805px;
      height: 81px;
      // margin-left: 53px;
      box-sizing: border-box;
      padding: 0 30px;
      transform: translateX(-12px) translateY(-12px);
      .line {
        height: 17px;
        margin-top: 32px;
        background: linear-gradient(
          0deg,
          #0f5dd9,
          #2349c0,
          #0f5dd9,
          #58c2f5,
          #8eedfc,
          #00bff9
        );
        border-radius: 8px;
        position: relative;
        .score {
          width: 67px;
          height: 33px;
          text-align: center;
          background-image: url('../../../assets/images/icon_pointframe.png');
          background-size: 100% 100%;
          position: absolute;
          top: 22px;
          right: -33px;
          font-size: 16px;
          font-family: 'FZCuYuan-M03S';
          color: #ffffff;
          -webkit-text-stroke: 1px #ff680d;
          text-stroke: 1px #ff680d;
          box-sizing: border-box;
          padding-top: 12px;
        }
      }
    }
  }

  .el-carousel,
  .el-carousel__container {
    overflow: visible;
  }

  .el-carousel__item {
    width: 874px;
    height: 248px;
  }

  .el-carousel__indicator {
    padding: 5px 8px;

    &.is-active button {
      background-color: rgba(0, 0, 0, 0.4);
    }
  }

  .el-carousel__button {
    width: 10px;
    height: 10px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.1);
    opacity: 1;
  }

  .el-carousel__arrow {
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    font-size: 14px;
    background-position: center center;
    background-repeat: no-repeat;
    outline: 0 none;

    i {
      display: none;
    }

    &--left {
      left: -50px;
      background-image: url('../../../assets/images/ico_arrow_l.svg');
    }

    &--right {
      right: -50px;
      background-image: url('../../../assets/images/ico_arrow_r.svg');
    }

    &:hover {
      background-color: #ffffff;
    }
  }
}

.level-desc-dialog {
  .el-dialog__header {
    padding-left: 50px;
    font-size: 24px;
    color: #262626;
  }

  .el-dialog__body {
    padding: 10px 50px 20px 50px;
  }
}
</style>
<style lang='scss' scoped>
.rights {
  .title {
    padding: 0 35px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dadada;
    height: 60px;
    line-height: 60px;
    align-items: center;
    div:first-child {
      font-size: 24px;
      font-weight: 400;
      font-family: Microsoft YaHei UI;
      color: #333;
    }
    div {
      color: #9c9c9c;
      font-size: 16px;
    }
  }
  .main {
    position: relative;
  }
  // .main {
  //   width: 976px;
  //   // padding-bottom: 120px;
  //   margin-bottom: -29px;
  // }
}

.level-desc {
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: rgba(140, 140, 140, 1);
  padding-top: 5px;

  span {
    padding-right: 20px;
    background: url('../../../assets/images/ico_levelinfo.svg') no-repeat center right;
    cursor: pointer;
  }
}

.q-group {
  color: #595959;
  font-size: 16px;
  margin-bottom: 30px;
}

.c-item,
.level-list-wrap {
  width: 874px;
  height: 248px;
}

.level-carousel {
  // width: 960px;
  // height: 410px;
}

.level-list-wrap {
  overflow: hidden;
  position: relative;
}

.level-carousel {
  // margin: 0 auto;
}

.c-item {
  position: relative;
  background-position: 0 0;
  background-repeat: no-repeat;
}

@each $bg in stardust, nebula, star, giant, superstar, supernova, blackhole {
  .c-box-#{$bg} {
    background-image: url('../../../assets/images/ico_#{$bg}.png');
  }
}

.name {
  color: #ffffff;
  font-size: 40px;
  position: absolute;
  left: 50px;
  top: 38px;
}

.twoname {
  position: absolute;
  color: rgba(255, 255, 255, 1);
  opacity: 0.4;
  font-size: 24px;
  left: 50px;
  top: 90px;
}

.level-text {
  position: absolute;
  left: 50px;
  bottom: 50px;

  .line {
    width: 260px;
    height: 2px;
    overflow: hidden;
    background-color: rgba($color: #ffffff, $alpha: 0.2);

    &-holder {
      width: 95px;
      height: 2px;
      background-color: #ffffff;
    }
  }

  .text {
    color: #ffffff;
    padding-top: 5px;
  }
}

.lock-mask {
  position: absolute;
  left: 9px;
  top: 6px;
  width: 856px;
  height: 230px;
  background: rgba(25, 33, 41, 0.6);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  .text {
    color: #ffffff;
    background: url('../../../assets/images/ico_lock.svg') no-repeat 0 center;
    padding-left: 24px;
  }
}

.level-info {
  padding: 32px 0px 0px 36px;
  h3 {
    text-align: center;
    font-weight: 400;
    font-size: 26px;
    font-family: 'FZCuYuan-M03S';
    color: #ffffff;

    span {
      display: inline-block;
      background: url('../../../assets/images/img_decorate_l.svg') no-repeat left center,
        url('../../../assets/images/img_decorate_r.svg') no-repeat right center;
      padding: 0 40px;
    }
  }
}

.info-list {
  width: 874px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  padding-top: 40px;

  .item {
    width: 289px;
    min-height: 175px;
    text-align: center;
    line-height: 22px;
  }

  .icon {
    display: inline-block;
    width: 48px;
    height: 48px;
    margin-bottom: 16px;
  }

  .tit {
    margin-bottom: 6px;
    // color: #262626;
    // font-size: 18px;

    // width: 121px;
    // height: 19px;
    font-size: 19px;
    font-family: 'FZCuYuan-M03S';
    font-weight: 400;
    color: #c8c8c8;
    // line-height: 43px;
  }

  .info {
    color: #8c8c8c;
    font-size: 14px;

    p {
      line-height: 19px;
    }
  }
}

@each $icon in ewcdsl, ffdsgn, xbsr, mndsr, sjfxptqx, ngsdsyqx {
  .icon-#{$icon} {
    background-image: url('../../../assets/images/ico_#{$icon}.png');
    background-repeat: no-repeat;
  }
}
.content-wrapper {
  padding: 0;
}
// .loading {
//   min-height: 200px;
// }
</style>
